import { render } from "./modal.vue?vue&type=template&id=bf80fcc4&scoped=true&ts=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"

import "./modal.vue?vue&type=style&index=0&id=bf80fcc4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf80fcc4"]])

export default __exports__